
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-53eb166e\",\"scoped\":false,\"hasInlineConfig\":true}!stylus-loader?sourceMap!../../vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-53eb166e\"}!../../vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-datepicker/src/index.vue
// module id = 22
// module chunks = 40